import React, { useEffect, useState } from 'react';
import { Button, message, Table } from 'antd';
import { PlusOutlined, EditOutlined } from '@ant-design/icons';
import AddContentModal from '../components/ContentManagement/AddContentModal';
import { GetData } from '../apiService/GetData';
import { apis } from '../properties';
import useBreadCrumb from './../hooks/useBreadCrumb';
import { useLocation } from 'react-router-dom';

function ContentManagementPage() {
    const location = useLocation();
    useBreadCrumb("Content Management", location.pathname, "Content Management");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [existingSections, setExistingSections] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editingSection, setEditingSection] = useState(null); // Track which section we are editing

    const fetchSections = () => {
        setLoading(true);
        GetData(apis.SECTION_CONTENT)
            .then(data => {
                setExistingSections(data);
                setLoading(false);
            })
            .catch(err => {
                message.error("Failed to fetch sections");
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchSections();
    }, []);

    const handleOpenModal = (record = null) => {
        setEditingSection(record); // If record is null, it's "Create" mode. If record has data, it's "Edit" mode.
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setEditingSection(null);
    };

    // const handleFormSubmit = async (finalData) => {
    //     try {
    //         message.success("Saved successfully!");
    //         setIsModalOpen(false);
    //         fetchSections();
    //     } catch (error) {
    //         message.error("Failed to save.");
    //     }
    // };

    const columns = [
        {
            title: 'Section Name',
            dataIndex: 'section_key',
            key: 'section_key',
            render: (text) => <strong>{text}</strong>,
        },
         {
            title: 'Section Title',
            dataIndex: 'section_title',
            key: 'section_title',
            render: (text) => <strong>{text}</strong>,
        },
        {
            title: 'Updated Date',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            render: (date) => date ? new Date(date).toLocaleDateString() : 'N/A',
        },
        {
            title: 'Actions',
            key: 'action',
            render: (_, record) => (
                <Button
                    icon={<EditOutlined />}
                    onClick={() => handleOpenModal(record)}
                >
                    Update Content
                </Button>
            ),
        },
    ];

    return (
        <div style={{ padding: '40px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h1>Content Management</h1>
                {/* <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => handleOpenModal(null)}
                >
                    Create New Section
                </Button> */}
            </div>

            <Table
                dataSource={existingSections}
                columns={columns}
                rowKey="_id"
                loading={loading}
            />

            <AddContentModal
                visible={isModalOpen}
                onCancel={handleCancel}
                onSubmitSuccess={fetchSections}
                initialValues={editingSection}
            />
        </div>
    );
}

export default ContentManagementPage;